import { apiActionTypeCreator } from "../../common";

export const userActionTypes = (transform) => ({
  REQUEST: undefined,
  SUCCESS: apiActionTypeCreator((response) => ({
    user: transform ?
      transform(response) :
      response
  })),
  FAILED: apiActionTypeCreator((error) => ({ error }))
});


// WEBPACK FOOTER //
// ./src/state/modules/user/configurations/util.js